import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {
    minHeight: "inherit",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  grid: {
    "& .MuiTableContainer-root": {
      overflowY: "hidden",
    },
  },
  productLengthTitle: {
    color: "#465869",
    fontWeight: 600,
    marginRight: "8px",
  },
  actionExtraIcon: {
    cursor: "pointer",
    marginLeft: "3px",
  },
  actionButtons: {
    marginTop: 12,
    width: "100%",
  },
  quantityDiv: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  quantityInput: {
    maxWidth: "120px",
    "& .MuiOutlinedInput-root": {
      height: "32px",
    },
  },
  title: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    border: "1px solid #E4E7EC",
    borderRadius: "8px",
    padding: "4px 12px",
    font: "normal 600 18px/24px Manrope",
    color: "#465869",
  },
  totalQuantityLabel: {
    font: "normal 700 20px/24px Manrope",
  },
  status: {
    maxWidth: "10%",
  },
}));

export default styles;
